module.exports = __webpack_public_path__ + "img/price1.5332fd97.png";